<template>
  <div class="transit-symbol-icon-root">
    <div v-if="isDefaultIcon || imgError" class="token-icon-block" :style="styleObj">
      {{ symbolFirstChar }}
    </div>
    <img
      v-else
      :src="icon"
      :alt="symbol"
      class="token-icon-image"
      @error="onImgError"
      :style="styleObj"
    />
  </div>
</template>

<script>
export default {
  name: "TransitSymbolIcon",
  props: {
    icon: {
      type: String,
      required: true,
    },
    symbol: {
      type: String,
      required: true,
    },
    fontsSize: {
      type: String,
      default: "20px",
    },
    styleObj: {
      type: Object,
      default: () => ({ fontSize: "20px", borderRadius: "50%" }),
    },
  },
  data() {
    return {
      imgError: false,
    };
  },
  computed: {
    isDefaultIcon() {
      return this.icon === "https://tokenpocket.gz.bcebos.com/common.png";
    },
    symbolFirstChar() {
      if (!this.symbol || typeof this.symbol !== "string" || this.symbol.trim().length === 0) {
        return "?";
      }
      let char = Array.from(this.symbol.trim())[0];
      if (/^[a-zA-Z]$/.test(char)) {
        return char.toUpperCase();
      }
      return char;
    },
  },
  watch: {
    icon() {
      // 只要图片地址变了，就重置错误状态
      this.imgError = false;
    },
  },
  methods: {
    onImgError() {
      this.imgError = true;
    },
  },
};
</script>

<style scoped>
.transit-symbol-icon-root {
  width: 100%;
  height: 100%;
  display: flex;
  /* 让内容撑满外层容器 */
  align-items: center;
  justify-content: center;
}
/* 蓝色圆块样式 */
.token-icon-block {
  background: #2980FE;
  color: #fff;
  border-radius: 50%;
  width: 100%;
  height: 100%;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  user-select: none;
  line-height: 1;
}
/* 图片样式 */
.token-icon-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  display: block;
}
</style>
